import { formFieldTypes, formValidations, appLoader, overlayLoader, toaster, tooltipMode } from '@/helpers/form';
import Vue from 'vue';
import ar from './ar';

export const local = ar;

Vue.prototype.local = ar;
Vue.prototype.formFieldType = formFieldTypes;
Vue.prototype.tooltipMode = tooltipMode;
Vue.prototype.formValidation = formValidations;
Vue.prototype.appLoader = appLoader;
Vue.prototype.overlayLoader = overlayLoader;
Vue.prototype.toaster = toaster;
